module.exports = __webpack_public_path__ + "img/evse_item-v2.fa43264b.svg";